import { SignupForm } from '@/features/auth/signup-form'

function SignupPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <div className="w-full max-w-md">
        <SignupForm />
      </div>
    </div>
  )
}

export { SignupPage }
